// extracted by mini-css-extract-plugin
var _1 = "PostSeriesFooter-module__animateUploadProgressBarWidth--N2T4l";
var _2 = "PostSeriesFooter-module__animatedBackground--zot0k";
var _3 = "PostSeriesFooter-module__container--zqM91";
var _4 = "PostSeriesFooter-module__icon--mhPrE";
var _5 = "PostSeriesFooter-module__meta--svgRW";
var _6 = "PostSeriesFooter-module__nextOrRestart--SBmVI";
var _7 = "PostSeriesFooter-module__paginationItem--_Ccvt";
var _8 = "PostSeriesFooter-module__postDetails--RYs5P";
var _9 = "PostSeriesFooter-module__postTitle--G0pZw";
var _a = "PostSeriesFooter-module__prev--WicRN";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "icon", _5 as "meta", _6 as "nextOrRestart", _7 as "paginationItem", _8 as "postDetails", _9 as "postTitle", _a as "prev" }
